import { render, staticRenderFns } from "./MarketReceivers.vue?vue&type=template&id=f4b06a3c&scoped=true"
import script from "./MarketReceivers.vue?vue&type=script&lang=js"
export * from "./MarketReceivers.vue?vue&type=script&lang=js"
import style0 from "./MarketReceivers.vue?vue&type=style&index=0&id=f4b06a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b06a3c",
  null
  
)

export default component.exports